// Auto generated file, do not manually modify!
// com.hotpads.satellite.client.message.type.SatelliteConversationMessageType

export enum SatelliteConversationMessageType {
  /**
   * @deprecated
   */
  APPLICATION_ACCEPTED = 'APPLICATION_ACCEPTED',
  APPLICATION_ACCESS_REMOVED = 'APPLICATION_ACCESS_REMOVED',
  APPLICATION_APPROVED_OFF_PLATFORM = 'APPLICATION_APPROVED_OFF_PLATFORM',
  APPLICATION_CONDITIONALLY_APPROVED = 'APPLICATION_CONDITIONALLY_APPROVED',
  APPLICATION_CONTACT = 'APPLICATION_CONTACT',
  APPLICATION_CO_APPLICANT_INVITATION = 'APPLICATION_CO_APPLICANT_INVITATION',
  APPLICATION_DECLINED = 'APPLICATION_DECLINED',
  /**
   * @deprecated
   */
  APPLICATION_INVITATION = 'APPLICATION_INVITATION',
  APPLICATION_INVITATION_V2 = 'APPLICATION_INVITATION_V2',
  APPLICATION_INVITED_TO_MOVE_IN = 'APPLICATION_INVITED_TO_MOVE_IN',
  APPLICATION_OPENED = 'APPLICATION_OPENED',
  APPLICATION_RECEIVED = 'APPLICATION_RECEIVED',
  APPLICATION_REQUEST = 'APPLICATION_REQUEST',
  APPLICATION_RESUBMIT_REQUEST = 'APPLICATION_RESUBMIT_REQUEST',
  APPLICATION_UNREAD = 'APPLICATION_UNREAD',
  /**
   * @deprecated
   */
  APPLICATION_UNREAD_IRENE = 'APPLICATION_UNREAD_IRENE',
  /**
   * @deprecated
   */
  APPLICATION_UNREAD_RACHEL = 'APPLICATION_UNREAD_RACHEL',
  APPLICATION_WITHDRAWN = 'APPLICATION_WITHDRAWN',
  /**
   * @deprecated
   */
  BACKGROUND_CHECK_AVAILABLE = 'BACKGROUND_CHECK_AVAILABLE',
  CONVERSATION_BLOCKED_BY_ZILLOW = 'CONVERSATION_BLOCKED_BY_ZILLOW',
  DEACTIVATE_LISTING_REMINDER = 'DEACTIVATE_LISTING_REMINDER',
  INSTANT_TOUR_CANCELED = 'INSTANT_TOUR_CANCELED',
  INSTANT_TOUR_REMINDER_24HR = 'INSTANT_TOUR_REMINDER_24HR',
  INSTANT_TOUR_RESCHEDULED = 'INSTANT_TOUR_RESCHEDULED',
  INSTANT_TOUR_SCHEDULED = 'INSTANT_TOUR_SCHEDULED',
  LEAD_SENT = 'LEAD_SENT',
  LEASE_ACTIVE = 'LEASE_ACTIVE',
  LEASE_COUNTERSIGNING_COMPLETE = 'LEASE_COUNTERSIGNING_COMPLETE',
  LEASE_EXPIRED = 'LEASE_EXPIRED',
  LEASE_EXPIRING_SOON = 'LEASE_EXPIRING_SOON',
  LEASE_RENEWAL_REMINDER = 'LEASE_RENEWAL_REMINDER',
  LEASE_RENEWAL_REVIEW_DRAFT = 'LEASE_RENEWAL_REVIEW_DRAFT',
  LEASE_SENT_FOR_OFFLINE_SIGNING = 'LEASE_SENT_FOR_OFFLINE_SIGNING',
  LEASE_SENT_FOR_ONLINE_SIGNING = 'LEASE_SENT_FOR_ONLINE_SIGNING',
  LEASE_SIGNED_BY_LAST_TENANT = 'LEASE_SIGNED_BY_LAST_TENANT',
  LEASE_SIGNED_BY_TENANTS_SOME_REMAINING = 'LEASE_SIGNED_BY_TENANTS_SOME_REMAINING',
  LEASE_SIGNING_CANCELLED = 'LEASE_SIGNING_CANCELLED',
  LISTING_MESSAGE = 'LISTING_MESSAGE',
  MARKED_AS_TENANT = 'MARKED_AS_TENANT',
  MESSAGE_QUARANTINED = 'MESSAGE_QUARANTINED',
  MESSAGE_RESTRICTED = 'MESSAGE_RESTRICTED',
  PAYMENTS_LANDLORD_ENDED_LEASE = 'PAYMENTS_LANDLORD_ENDED_LEASE',
  PAYMENTS_LANDLORD_EXTENDED_LEASE = 'PAYMENTS_LANDLORD_EXTENDED_LEASE',
  PAYMENTS_LANDLORD_LEASE_TO_M2M = 'PAYMENTS_LANDLORD_LEASE_TO_M2M',
  PAYMENTS_LANDLORD_REQUESTED_ONE_TIME_PAYMENT = 'PAYMENTS_LANDLORD_REQUESTED_ONE_TIME_PAYMENT',
  PAYMENTS_LANDLORD_REQUESTED_RENT_AMOUNT_CHANGE = 'PAYMENTS_LANDLORD_REQUESTED_RENT_AMOUNT_CHANGE',
  PAYMENTS_LANDLORD_SHORTENED_LEASE = 'PAYMENTS_LANDLORD_SHORTENED_LEASE',
  PAYMENTS_OTP_REQUEST_PAID = 'PAYMENTS_OTP_REQUEST_PAID',
  PAYMENTS_OTP_REQUEST_SENT = 'PAYMENTS_OTP_REQUEST_SENT',
  PAYMENTS_PAYOUT_CREATED = 'PAYMENTS_PAYOUT_CREATED',
  PAYMENTS_PAYOUT_DELAYED = 'PAYMENTS_PAYOUT_DELAYED',
  PAYMENTS_RENTER_ONBOARDING_REMINDER = 'PAYMENTS_RENTER_ONBOARDING_REMINDER',
  PAYMENTS_RENTER_PAYMENT_COMPLETE = 'PAYMENTS_RENTER_PAYMENT_COMPLETE',
  PAYMENTS_RENTER_PAYMENT_ENDING = 'PAYMENTS_RENTER_PAYMENT_ENDING',
  PAYMENTS_RENTER_PAYMENT_FAILED = 'PAYMENTS_RENTER_PAYMENT_FAILED',
  PAYMENTS_RENTER_PAYMENT_INVITE = 'PAYMENTS_RENTER_PAYMENT_INVITE',
  PAYMENTS_RENTER_PAYMENT_OVERDUE = 'PAYMENTS_RENTER_PAYMENT_OVERDUE',
  PAYMENTS_RENTER_RENT_OVERDUE = 'PAYMENTS_RENTER_RENT_OVERDUE',
  PAYMENTS_RENTER_SCHEDULED_FIRST_PAYMENT = 'PAYMENTS_RENTER_SCHEDULED_FIRST_PAYMENT',
  PAYMENTS_RENTER_SCHEDULED_PAYMENT = 'PAYMENTS_RENTER_SCHEDULED_PAYMENT',
  PAYMENTS_RENTER_UPCOMING_PAYMENT = 'PAYMENTS_RENTER_UPCOMING_PAYMENT',
  PAYMENTS_RENT_AMOUNT_CHANGED_FOR_PROPERTY = 'PAYMENTS_RENT_AMOUNT_CHANGED_FOR_PROPERTY',
  PAYMENTS_RENT_PAID = 'PAYMENTS_RENT_PAID',
  PAYMENTS_RENT_PAID_OFFLINE = 'PAYMENTS_RENT_PAID_OFFLINE',
  PHONE_LEAD = 'PHONE_LEAD',
  RENTER_PROFILE_REQUEST = 'RENTER_PROFILE_REQUEST',
  RENTER_PROFILE_SUBMISSION = 'RENTER_PROFILE_SUBMISSION',
  TOUR_CANCELED = 'TOUR_CANCELED',
  TOUR_CANCELED_BY_RENTER = 'TOUR_CANCELED_BY_RENTER',
  TOUR_CONFIRMED = 'TOUR_CONFIRMED',
  TOUR_DECLINED = 'TOUR_DECLINED',
  TOUR_INSTANT_BOOKED = 'TOUR_INSTANT_BOOKED',
  TOUR_REMINDER_24HR = 'TOUR_REMINDER_24HR',
  TOUR_REMINDER_4HR = 'TOUR_REMINDER_4HR',
  TOUR_REQUESTED = 'TOUR_REQUESTED',
  TOUR_REQUEST_CANCELED_BY_RENTER = 'TOUR_REQUEST_CANCELED_BY_RENTER',
  TOUR_REQUEST_EXPIRED = 'TOUR_REQUEST_EXPIRED',
  TOUR_REQUEST_QUICK = 'TOUR_REQUEST_QUICK',
  TOUR_RESCHEDULED_BY_LANDLORD = 'TOUR_RESCHEDULED_BY_LANDLORD',
  TOUR_RESCHEDULED_INSTANT = 'TOUR_RESCHEDULED_INSTANT',
  TOUR_RESCHEDULED_REVIEW = 'TOUR_RESCHEDULED_REVIEW',
  VAL_AI_SUGGESTION = 'VAL_AI_SUGGESTION',
}

export const SatelliteConversationMessageType_values = [
  SatelliteConversationMessageType.APPLICATION_ACCEPTED,
  SatelliteConversationMessageType.APPLICATION_ACCESS_REMOVED,
  SatelliteConversationMessageType.APPLICATION_APPROVED_OFF_PLATFORM,
  SatelliteConversationMessageType.APPLICATION_CONDITIONALLY_APPROVED,
  SatelliteConversationMessageType.APPLICATION_CONTACT,
  SatelliteConversationMessageType.APPLICATION_CO_APPLICANT_INVITATION,
  SatelliteConversationMessageType.APPLICATION_DECLINED,
  SatelliteConversationMessageType.APPLICATION_INVITATION,
  SatelliteConversationMessageType.APPLICATION_INVITATION_V2,
  SatelliteConversationMessageType.APPLICATION_INVITED_TO_MOVE_IN,
  SatelliteConversationMessageType.APPLICATION_OPENED,
  SatelliteConversationMessageType.APPLICATION_RECEIVED,
  SatelliteConversationMessageType.APPLICATION_REQUEST,
  SatelliteConversationMessageType.APPLICATION_RESUBMIT_REQUEST,
  SatelliteConversationMessageType.APPLICATION_UNREAD,
  SatelliteConversationMessageType.APPLICATION_UNREAD_IRENE,
  SatelliteConversationMessageType.APPLICATION_UNREAD_RACHEL,
  SatelliteConversationMessageType.APPLICATION_WITHDRAWN,
  SatelliteConversationMessageType.BACKGROUND_CHECK_AVAILABLE,
  SatelliteConversationMessageType.CONVERSATION_BLOCKED_BY_ZILLOW,
  SatelliteConversationMessageType.DEACTIVATE_LISTING_REMINDER,
  SatelliteConversationMessageType.INSTANT_TOUR_CANCELED,
  SatelliteConversationMessageType.INSTANT_TOUR_REMINDER_24HR,
  SatelliteConversationMessageType.INSTANT_TOUR_RESCHEDULED,
  SatelliteConversationMessageType.INSTANT_TOUR_SCHEDULED,
  SatelliteConversationMessageType.LEAD_SENT,
  SatelliteConversationMessageType.LEASE_ACTIVE,
  SatelliteConversationMessageType.LEASE_COUNTERSIGNING_COMPLETE,
  SatelliteConversationMessageType.LEASE_EXPIRED,
  SatelliteConversationMessageType.LEASE_EXPIRING_SOON,
  SatelliteConversationMessageType.LEASE_RENEWAL_REMINDER,
  SatelliteConversationMessageType.LEASE_RENEWAL_REVIEW_DRAFT,
  SatelliteConversationMessageType.LEASE_SENT_FOR_OFFLINE_SIGNING,
  SatelliteConversationMessageType.LEASE_SENT_FOR_ONLINE_SIGNING,
  SatelliteConversationMessageType.LEASE_SIGNED_BY_LAST_TENANT,
  SatelliteConversationMessageType.LEASE_SIGNED_BY_TENANTS_SOME_REMAINING,
  SatelliteConversationMessageType.LEASE_SIGNING_CANCELLED,
  SatelliteConversationMessageType.LISTING_MESSAGE,
  SatelliteConversationMessageType.MARKED_AS_TENANT,
  SatelliteConversationMessageType.MESSAGE_QUARANTINED,
  SatelliteConversationMessageType.MESSAGE_RESTRICTED,
  SatelliteConversationMessageType.PAYMENTS_LANDLORD_ENDED_LEASE,
  SatelliteConversationMessageType.PAYMENTS_LANDLORD_EXTENDED_LEASE,
  SatelliteConversationMessageType.PAYMENTS_LANDLORD_LEASE_TO_M2M,
  SatelliteConversationMessageType.PAYMENTS_LANDLORD_REQUESTED_ONE_TIME_PAYMENT,
  SatelliteConversationMessageType.PAYMENTS_LANDLORD_REQUESTED_RENT_AMOUNT_CHANGE,
  SatelliteConversationMessageType.PAYMENTS_LANDLORD_SHORTENED_LEASE,
  SatelliteConversationMessageType.PAYMENTS_OTP_REQUEST_PAID,
  SatelliteConversationMessageType.PAYMENTS_OTP_REQUEST_SENT,
  SatelliteConversationMessageType.PAYMENTS_PAYOUT_CREATED,
  SatelliteConversationMessageType.PAYMENTS_PAYOUT_DELAYED,
  SatelliteConversationMessageType.PAYMENTS_RENTER_ONBOARDING_REMINDER,
  SatelliteConversationMessageType.PAYMENTS_RENTER_PAYMENT_COMPLETE,
  SatelliteConversationMessageType.PAYMENTS_RENTER_PAYMENT_ENDING,
  SatelliteConversationMessageType.PAYMENTS_RENTER_PAYMENT_FAILED,
  SatelliteConversationMessageType.PAYMENTS_RENTER_PAYMENT_INVITE,
  SatelliteConversationMessageType.PAYMENTS_RENTER_PAYMENT_OVERDUE,
  SatelliteConversationMessageType.PAYMENTS_RENTER_RENT_OVERDUE,
  SatelliteConversationMessageType.PAYMENTS_RENTER_SCHEDULED_FIRST_PAYMENT,
  SatelliteConversationMessageType.PAYMENTS_RENTER_SCHEDULED_PAYMENT,
  SatelliteConversationMessageType.PAYMENTS_RENTER_UPCOMING_PAYMENT,
  SatelliteConversationMessageType.PAYMENTS_RENT_AMOUNT_CHANGED_FOR_PROPERTY,
  SatelliteConversationMessageType.PAYMENTS_RENT_PAID,
  SatelliteConversationMessageType.PAYMENTS_RENT_PAID_OFFLINE,
  SatelliteConversationMessageType.PHONE_LEAD,
  SatelliteConversationMessageType.RENTER_PROFILE_REQUEST,
  SatelliteConversationMessageType.RENTER_PROFILE_SUBMISSION,
  SatelliteConversationMessageType.TOUR_CANCELED,
  SatelliteConversationMessageType.TOUR_CANCELED_BY_RENTER,
  SatelliteConversationMessageType.TOUR_CONFIRMED,
  SatelliteConversationMessageType.TOUR_DECLINED,
  SatelliteConversationMessageType.TOUR_INSTANT_BOOKED,
  SatelliteConversationMessageType.TOUR_REMINDER_24HR,
  SatelliteConversationMessageType.TOUR_REMINDER_4HR,
  SatelliteConversationMessageType.TOUR_REQUESTED,
  SatelliteConversationMessageType.TOUR_REQUEST_CANCELED_BY_RENTER,
  SatelliteConversationMessageType.TOUR_REQUEST_EXPIRED,
  SatelliteConversationMessageType.TOUR_REQUEST_QUICK,
  SatelliteConversationMessageType.TOUR_RESCHEDULED_BY_LANDLORD,
  SatelliteConversationMessageType.TOUR_RESCHEDULED_INSTANT,
  SatelliteConversationMessageType.TOUR_RESCHEDULED_REVIEW,
  SatelliteConversationMessageType.VAL_AI_SUGGESTION,
] as const;
